import { AnyAction } from '@reduxjs/toolkit';

import { State } from '../types/state.interface';

import { Employee } from '../interfaces/employee/employee.interface';

import { EmployeeActions } from '../actions/employee/employee.actions';

export interface EmployeeState extends State {
  employees: Employee[];
  employee?: Employee;
}

export const initialState: EmployeeState = {
  employees: []
};

export const employeeReducer = (state: EmployeeState = initialState, action: AnyAction) => {
  if (action.type === EmployeeActions.SET_EMPLOYEES) {
    const { employees } = action;
    return {
      ...state,
      employees
    };
  } else if (action.type === EmployeeActions.SET_EMPLOYEE) {
    const { employee } = action;
    // v3: also patch the matching entry inside `employees[]` so list views
    // reflect the saved values without a full /employees refetch.
    const patched = state.employees.map((e) =>
      String(e.id) === String(employee?.id) ? { ...e, ...employee } : e
    );
    return {
      ...state,
      employee,
      employees: patched
    };
  }

  return state;
};
